/**
 * Cifras ficticias para probar la carga. No son un estado de resultados real.
 * Con giro 541211: sueldos queda en rango, arrendamiento en alto y publicidad
 * saldría de rango, pero la fila EJEMPLO no se pinta en rojo.
 */
export const EJEMPLO_GIRO = {
  giro_scian: "541211",
  giro_descripcion: "Servicios de contabilidad y auditoría",
  origen_giro: "manual",
  guardado: false,
  mensaje: "Origen: manual. Puede modificar el giro.",
  actividad_orden: null,
  actividad_descripcion: "",
  actividad_porcentaje: null,
};

export const EJEMPLO_RENGLONES = [
  { etiqueta_original: "Ventas netas", importe: 1000000, rubro: "ventas_netas" },
  { etiqueta_original: "Costo de ventas", importe: 400000, rubro: "costo_ventas" },
  { etiqueta_original: "Sueldos y salarios", importe: 350000, rubro: "sueldos" },
  { etiqueta_original: "Arrendamiento del local", importe: 90000, rubro: "arrendamiento" },
  { etiqueta_original: "Publicidad", importe: 50000, rubro: "publicidad" },
  { etiqueta_original: "Honorarios profesionales", importe: 80000, rubro: "honorarios" },
  { etiqueta_original: "Utilidad bruta", importe: 600000, rubro: "ignorar", ignorar: true },
];

export function ejemploParaMes(mes) {
  return EJEMPLO_RENGLONES.map((row, idx) => ({
    idx,
    ...row,
    mes: Number(mes) || null,
    ignorar: Boolean(row.ignorar) || row.rubro === "ignorar",
    rubro_sugerido: row.rubro,
    rubro_origen: "ejemplo",
  }));
}
